import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AlertifyService } from 'src/app/services/alertify.service';
import { PlanService } from 'src/app/services/plan.service';

@Component({
  selector: 'app-index-consutla-planes',
  templateUrl: './index-consutla-planes.component.html',
  styleUrls: ['./index-consutla-planes.component.scss']
})
export class IndexConsutlaPlanesComponent implements OnInit {
  public dataSource: any;
  displayedColumns: string[];
  
  constructor(
public planSvc:PlanService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = [
      'nombre',
      'descripcion',
      'mesesDeVigencia',
      'valor',
    ];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {
   // this.dataSource.paginator = this.paginator;
    this.getPlanes();
  }

  ngOnInit(): void {}


  getPlanes() {
   // this.isLoadingResults = true;
    this.planSvc
      .GetPlanesEmpresa()
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<any>(result);

        console.log('resultado: ', result);
      });
  }


}
